import DataTableCart from './DataTableCart';

export default DataTableCart;
